// extracted by mini-css-extract-plugin
module.exports = {"label":"Dropdown_label__M6Z4D","menu":"Dropdown_menu__p_JC5","link":"Dropdown_link__AOOjP"};